import { COMPLETE_INSTALL_STATUS, IN_PROGRESS_INSTALL_STATUS } from '../../../../../records/InstallMode/InstallStatus';
export default function foldShowAppSpecificPasswordInstallStatus(installStatus, inProgress, complete) {
  switch (installStatus.type) {
    case IN_PROGRESS_INSTALL_STATUS:
      return inProgress(installStatus);
    case COMPLETE_INSTALL_STATUS:
      return complete(installStatus);
    default:
      // Flow compile-time validation that we've handled every show app specific password install status
      // prettier-ignore
      installStatus;
      return undefined;
  }
}